import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

type Choice = {
    answer: string;
    isCorrect: boolean;
  }
  
  type Question = {
    question: string;
    explanation: string;
    attachment: string;
    figure: string[];
    choices: Choice[];
  }
  
  type QuizDTO = {
    name: string;
    description:string;
    category:string;
    certificateExamId:string;
    questionBanks: Question[];
  } & ApiError

export const CreateTopic = (data: QuizDTO): Promise<QuizDTO> => {
    return axios.post("/question-bank-category/create", data)
        .then(response => response.data as QuizDTO);
};
